import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouteReuseStrategy} from '@angular/router';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';

import {HttpClientModule} from '@angular/common/http';
import {NgChartsModule} from 'ng2-charts';
import {NgxTippyModule} from 'ngx-tippy-wrapper';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';

// Quill

import {QuillModule} from 'ngx-quill';
import * as Quill from 'quill';

const DirectionAttribute = Quill.import('attributors/attribute/direction');
Quill.register(DirectionAttribute, true);
const AlignClass = Quill.import('attributors/class/align');
Quill.register(AlignClass, true);
const BackgroundClass = Quill.import('attributors/class/background');
Quill.register(BackgroundClass, true);
const ColorClass = Quill.import('attributors/class/color');
Quill.register(ColorClass, true);
const DirectionClass = Quill.import('attributors/class/direction');
Quill.register(DirectionClass, true);
const FontClass = Quill.import('attributors/class/font');
Quill.register(FontClass, true);
const SizeClass = Quill.import('attributors/class/size');
Quill.register(SizeClass, true);
const AlignStyle = Quill.import('attributors/style/align');
Quill.register(AlignStyle, true);
const BackgroundStyle = Quill.import('attributors/style/background');
Quill.register(BackgroundStyle, true);
const ColorStyle = Quill.import('attributors/style/color');
Quill.register(ColorStyle, true);
const DirectionStyle = Quill.import('attributors/style/direction');
Quill.register(DirectionStyle, true);
const FontStyle = Quill.import('attributors/style/font');
Quill.register(FontStyle, true);
const SizeStyle = Quill.import('attributors/style/size');
Quill.register(SizeStyle, true);

class IndentAttributor extends Quill.import('parchment').Attributor.Style {
	multiplier = 2;

	constructor(name: string, style: string, params: any) {
		super(name, style, params);
	}

	add(node, value) {
		return super.add(node, `${value * this.multiplier}rem`);
	}

	value(node) {
		return parseFloat(super.value(node)) / this.multiplier || undefined;
	}
}

function createCustomIndent(): void {
	const levels = [1, 2, 3, 4, 5];
	const multiplier = 2;
	const indentStyle = new IndentAttributor('indent', 'margin-left', {
		scope: Quill.import('parchment').Scope.BLOCK,
		whitelist: levels.map(value => `${value * multiplier}rem`),
	});
	Quill.register(indentStyle);
}

createCustomIndent();

// End Quill

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		IonicModule.forRoot({
			innerHTMLTemplatesEnabled: true
		}),
		AppRoutingModule,
		HttpClientModule,
		NgChartsModule,
		NgxTippyModule,
		QuillModule.forRoot({
			modules: {
				toolbar: [
					['bold', 'italic', 'underline', 'strike'],
					[{'list': 'ordered'}, {'list': 'bullet'}],
					[{'color': []}, {'background': []}],
					[{'align': []}],
					[{'indent': '-1'}, {'indent': '+1'}]
				],
				clipboard: {
					matchers: [
						[Node.ELEMENT_NODE, (Node.ELEMENT_NODE, (node, delta) => {
							delta.ops = delta.ops.map(op => {
								return {
									insert: op.insert
								}
							})
							return delta
						})
						]
					]
				}
			},
			placeholder: '',
		}),
		LeafletModule
	],
	providers: [{provide: RouteReuseStrategy, useClass: IonicRouteStrategy}],
	bootstrap: [AppComponent],
})
export class AppModule {
}
